import { render, staticRenderFns } from "./RecoderExam.vue?vue&type=template&id=a10e0ec0&scoped=true&"
import script from "./RecoderExam.vue?vue&type=script&lang=js&"
export * from "./RecoderExam.vue?vue&type=script&lang=js&"
import style0 from "./RecoderExam.vue?vue&type=style&index=0&id=a10e0ec0&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10e0ec0",
  null
  
)

export default component.exports